import React from 'react';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';

export const PrevCheckboxElement = ({ item, value }) => {
    const options = (item?.properties?.options || []).filter((opt) => opt.name && opt.name.trim() !== '');
    const selectedValues = Array.isArray(value) ? value : [];

    return (
        <div>
            {/*<p className='preview-info-line-title' style={{fontSize: 16}}>{item?.label}</p>*/}
            <FormGroup>
                {options.map((opt) => (
                    <FormControlLabel
                        key={opt.id}
                        control={
                            <Checkbox
                                checked={selectedValues.some((s) => s.id === opt.id)}
                                color="primary"
                                style={{ padding: '4px 9px' }}
                            />
                        }
                        label={opt.name}
                    />
                ))}
            </FormGroup>
        </div>
    );
};
